import React from 'react';



const Name = (props)=>{
    const { nameStyle, spanStyle, originStyle,countryStyle, boldStyle } = styles;
    return(
        <p style={nameStyle}>
          <span>
          <span> 
              <span style={boldStyle}>Name</span> 
              <span style={spanStyle}>{props.currentName.name}</span> 
              </span>
                <span className = "underline--cool" style={originStyle}>is a {props.currentName.sex} Name and it's Origin is <span style={countryStyle}>
                {props.currentName.origin}
                </span>
            </span>
          </span>
          </p>
    )
}

const styles = {
    nameStyle:{
            width: "100%",
            marginTop: "5px",
            marginBottom: "0.5em",
            marginRight: "0.3em",
            },
    spanStyle:{
                fontFamily: "sans-serif",
                fontWeight: "bold",
                fontSize: "12px",
                color: "white",
                background: "#ede13e",
                borderRadius: "2px",
                padding: "4px",
                marginLeft: "2px",
                marginRight: "2px"
            },
    originStyle:{
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginLeft: "5px"
                },
    countryStyle:{
                    fontWeight: "bold",
                },
    boldStyle: {
                    fontWeight: "bold",
                    fontSize: "12px"
                }
}

export default Name;



// WEBPACK FOOTER //
// ./src/components/mainpage/box/name.js